import { Nav } from "@components/Settings/Nav";
import type { ComponentChildren } from "preact";
import { useTranslation } from "react-i18next";

interface LayoutProps {
  children: ComponentChildren;
}

export const Layout = ({ children }: LayoutProps) => {
  const { t } = useTranslation();

  return (
    <div className="lf-relative lf-flex lf-gap-6">
      <div className="lf-hidden lf-h-fit lf-sticky lf-top-24 md:lf-flex md:lf-flex-col">
        <span className="lf-text-[var(--gray-11)]">
          {t("navigation.settings")}
        </span>
        <Nav />
      </div>
      <div className="lf-w-full lf-flex lf-flex-col lf-min-w-0">{children}</div>
    </div>
  );
};
